import { createContext } from "react";
var SectionSpacingValueSpaceContext = /*#__PURE__*/createContext({
  top: 0,
  bottom: 0
});
export default SectionSpacingValueSpaceContext;